import VisualizationEvent from '@splunk/dashboard-visualizations/common/VisualizationEvent';

export const getClickHandler = (onEventTrigger, data, eventName = 'value.click') =>
    typeof onEventTrigger === 'function' &&
    (e =>
        onEventTrigger(new VisualizationEvent({ originalEvent: e, payload: { ...data }, type: eventName })));

export const enableClickHandler = (hasEventHandlers, mode) => !!hasEventHandlers && mode === 'view';
